import React, { useState, useEffect, useRef } from "react";
import { Grid, MenuItem } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import useSmsProvider from "../../../../hooks/useSmsProvider";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import { searchPayload } from "../../../../utils/common";
import CustomTextField from "../../../../components/CustomTextField";

const currentSmsProviderPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const currentRatePayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

function SmsSettings(props) {
  const { autoSearchSmsProvider, smsProviderAutoSearchResults } = useSmsProvider();
  const { t } = useTranslation();

  const { validationFields } = props;
  const {
    formState: { errors },
    control,
  } = useFormContext();

  const [smsProviderPayload, setSmsProviderPayload] = useState(currentSmsProviderPayload);
  const [smsProviderOptions, setSmsProviderOptions] = useState([]);

  const fetchSmsProviders = async () => {
    await autoSearchSmsProvider(smsProviderPayload);
  };

  useEffect(() => {
    fetchSmsProviders();
  }, [smsProviderPayload]);

  useEffect(() => {
    //console.log(ispOptions, "ispOptions", ispAutoSearchResults);
    if (smsProviderAutoSearchResults.data.length !== 0) {
      const results = [...smsProviderOptions, ...smsProviderAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      console.log(filteredResults, "filteredResults");
      setSmsProviderOptions(filteredResults);
    }
  }, [smsProviderAutoSearchResults]);

  return (
    <Grid container spacing={12} className="row" pt={8}>
      <Grid item xs={10} sm={12} md={6} lg={6} xl={4}>
        <SearchableAutoComplete
          control={control}
          data={smsProviderOptions}
          label={t("select_smsProvider")}
          payload={smsProviderPayload}
          setPayload={setSmsProviderPayload}
          loading={false}
          name="smsProvider"
          multiple={false}
          defaultValue={""}
          hasNextPage={false}
          fields={validationFields}
        />
      </Grid>
      <Grid item xs={10} sm={12} md={6} lg={6} xl={4}>
        <CustomTextField
          label={t("user_name")}
          name="smsUserName"
          type="text"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
      <Grid item md={6}>
        <CustomTextField
          label={t("password")}
          name="smsPassword"
          type="password"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
    </Grid>
  );
}

export default SmsSettings;
